import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from "react-router-dom";
import i18next from "i18next";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import ApiSearch from "../../services/Search";
import {API_SEARCH, GAME_ROUTE} from "../../utils/consts";
import {useFetching} from "../../hooks/useFetching";
import parse from "html-react-parser";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";

const Search = ({ logoOpacity, setLogoOpacity }) => {
    const {t} = useTranslation();
    const inputSearchRef = useRef(null);
    const [games, setGames] = useState([]);
    const [activeSearch, setActiveSearch] = useState(false);
    const [inputSearchValue, setInputSearchValue] = useState('');

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (activeSearch && inputSearchRef.current && !inputSearchRef.current.contains(e.target) && !e.target.closest('.search_clean')) {
                if (document.body.clientWidth <= 1280) setLogoOpacity(true);
                setActiveSearch(false);
                setInputSearchValue('')
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [activeSearch]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = (e) => {
        setInputSearchValue(e.target.value);
        if (e.target.value.length > 3) {
            FunctionApiSearch(e.target.value)
        }
    };

    const [FunctionApiSearch] = useFetching(async (text) => {
        const response = await ApiSearch.getApiSearch(API_SEARCH, text);
        setGames(response.data.games);
    });
    return (
        <form className={`search ${activeSearch ? 'active' : ''}`}
              onSubmit={(e) => e.preventDefault()}
        >
            <div ref={inputSearchRef}>
                <input
                    type="text"
                    placeholder={t('Search')}
                    value={inputSearchValue}
                    onChange={handleSearch}
                />
                {inputSearchValue.length > 0 && <button
                    className="search_clean"
                    type="button"
                    onClick={() => {
                        setInputSearchValue('');
                        inputSearchRef.current.querySelector('input').focus();
                    }}
                >
                    <svg width="10" height="10" viewBox="0 0 10 10">
                        <g>
                            <g>
                                <path fill="#fff"
                                      d="M9.296-.012l.716.716L5.716 5l4.296 4.296-.716.716L5 5.716.704 10.012l-.716-.716L4.284 5-.012.704l.716-.716L5 4.284z"/>
                            </g>
                        </g>
                    </svg>
                </button>}
            </div>
            {inputSearchValue.length > 3 && <div className='results'>
                <ul className={games.length > 0 ? '' : 'no_results'}>
                    <OverlayScrollbarsComponent>
                        {games.length > 0
                            ? games.map(game => <li key={game.url}>
                                <NavLink exact to={`/${i18next.language}${GAME_ROUTE}/${game.id}/`}>
                                    {parse(game.name.replace(new RegExp(inputSearchValue, 'ig'), '<span class="search_highlight">$&</span>'))}
                                </NavLink>
                            </li>)
                            : <li>{t('No results')}</li>
                        }
                    </OverlayScrollbarsComponent>
                </ul>
            </div>}
            <button
                className="submit"
                type="button"
                onClick={() => {
                    if (document.body.clientWidth <= 1280) setLogoOpacity(!logoOpacity);
                    setActiveSearch(!activeSearch);
                    activeSearch
                        ? inputSearchRef.current.querySelector('input').blur()
                        : inputSearchRef.current.querySelector('input').focus()
                }}
            >
                <svg width="15" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     viewBox="0 0 541 541.5"
                     style={{enableBackground: 'new 0 0 541 541.5'}}>
                    <path
                        d="M528.7,470L416.1,356.9C441.9,319.2,456,273.7,456,228C456,102.3,353.7,0,228,0C167,0,109.8,23.7,66.8,66.8 C23.7,109.8,0,167,0,228s23.7,118.2,66.8,161.2C109.8,432.3,167,456,228,456c45.6,0,91-14.1,128.7-39.8l112.6,113 c7.9,7.9,18.4,12.3,29.6,12.3c11.1,0,21.6-4.3,29.6-12.2c8-7.9,12.4-18.5,12.4-29.7C541,488.3,536.6,477.8,528.7,470z M228,371.9 c-79.4,0-144-64.6-144-143.9c0-79.4,64.6-144,144-144c79.4,0,144,64.6,144,144C372,307.3,307.4,371.9,228,371.9z"/>
                </svg>
            </button>
        </form>
    );
};

export default observer(Search);